const en = {
  acquisition_screen_title: 'New Vodafone Number',
  acquisition_offer_step_title: 'Your offer',
  acquisition_offer_step_subtitle: 'Choose a plan',
  acquisition_recommended_offer: 'Reccommended for you',
  acquisition_offer_button_title: 'Continue with this bundle',
  acquisition_id_step_title: 'Add your personal information',
  acquisition_id_step_subtitle: 'We need to take details of a valid from of identification so we can verify your identity. We need a photo of your ID to be able to do the check.',
  acquisition_id_step_card_title: 'My ID ',
  acquisition_id_step_card_subtitle: 'Personal information',
  acquisition_id_step_card_desc: 'Please enter the details of your ID to verify your identity and finalize the request.',
  acquisition_id_step_button_take_id_photo: 'Photo ID',
  acquisition_id_step_button_uploaded_id_photo: ' ID photo uploaded',
  acquisition_id_step_name: 'Name',
  acquisition_id_step_surname: 'Surname',
  acquisition_continue: 'Continue',
  acquisition_id_step_id_number: 'Personal Number',
  acquisition_id_step_id_wrong_format: 'Wrong personal number format',
  acquisition_id_step_birthday_label: 'Birthday',
  acquisition_id_step_date: 'DD',
  acquisition_id_step_month: 'MM',
  acquisition_id_step_year: 'YYYY',
  acquisition_id_step_day_not_valid: 'Not a valid day',
  acquisition_id_step_month_not_valid: 'Not a valid month',
  acquisition_id_step_year_not_valid: 'Not a valid year',
  acquisition_id_step_card_address_title: 'Postal Information',
  acquisition_id_step_card_address_subtitle: 'Enter Address',
  acquisition_id_step_address_title: 'SIM Delivery',
  acquisition_id_step_address_subtitle: 'Add the address where you want us to deliver the SIM',
  acquisition_id_step_city: 'City',
  acquisition_id_step_address: 'Address',
  acquisition_id_step_birthplace: 'Place of birth',
  acquisition_id_step_birthcountry: 'Country of birth',
  acquisition_id_step_citizenship: 'Citizenship',
  acquisition_id_step_gender: 'Gender',
  acquisition_id_step_document_type: 'Document type',
  aquisition_id_step_issueing_date_not_valid: 'Issueing Date is not valid',
  acquisition_id_step_mobile: 'Contact Number',
  acquisition_id_issue_date: 'Issueing Date',
  acquisition_id_step_phone_number_wrong_format: 'Wrong phone number format',
  acquisition_id_step_country: 'Country',
  acquisition_id_step_channel: 'Channel',
  acquisition_sim_step_title: 'Choose SIM',
  acquisition_sim_step_subtitle: 'Pick one of the available SIM',
  acquisition_sim_step_choose_number: 'Type a number of your choosing',
  acquisition_summary_step_offer_title: 'Offer selected',
  acquisition_summary_step_offer_subtitle: 'Offer activated upon activation',
  acquisition_summary_step_title: 'Summary',
  acquisition_summary_step_subtitle: 'Your new SIM will be delivered to you within 48 hours. Then, activate your service in My Vodafone at My Orders.',
  acquisition_summary_step_selected_sim_title: 'New Vodafone SIM',
  acquisition_summary_step_selected_sim_subtitle: 'Phone number',
  acquisition_summary_step_delivery_subtitle: 'Delivery address',
  acquisition_done: 'Confirm',
  acquisition_order_completion_success: 'Congratulations!',
  acquisition_order_completion_success_button_cancel: 'Cancel',
  acquisition_order_completion_error: 'Oops!',
  acquisition_order_completion_error_default_desc: 'Something went wrong.',
  acquisition_order_completion_success_default_desc: 'The request was submitted. Check the status under my orders',
  acquisition_check_order: 'Check order',
  acquisition_intro_screen_title: 'Get a new number for free and benefit from the best digital offer',
  acquisition_intro_screen_subtitle: 'Join the Vodafone family and benefit from the best experience in the market',
  acquisition_join_button: 'Get a new number',
  acquisition_verify_code_title: 'Verification code',
  acquisition_verify_code_subtitle: "We've sent the verification code to:",
  acquisition_verify_code_desc: 'Please enter the 4 digit code:',
  acquisition_verify_code_resend_code_disabled: 'Re-send code (%1$s)',
  acquisition_verify_code_resend_code: 'Re-send code',
  acquisition_verify_code_confirm: 'Confirm',
  acquisition_verify_code_cancel: 'Cancel',
  acquisition_go_back: 'Go back',
  acquisition_go_back_to_summary: 'Go back to summary',
  acquisition_loading_button: 'Loading',
  acquisition_try_again: 'Try again',
  acquisition_default_error: 'Oops!',
  acquisition_default_error_message: 'Something went wrong',
  acquisition_error_id_not_found: 'Provided information is not correct',
  acquisition_id_step_register: 'Register',
  acqusition_MOBILE_GB: 'GB',
  acqusition_INTERNATIONAL_SMS: 'international sms',
  acqusition_SMS: 'SMS',
  acqusition_INTERNATIONAL_MIN: 'international minutes',
  acqusition_MIN: 'minutes',
  acquisition_offer: 'Offer',
  acquisition_id: 'ID',
  acquisition_sim: 'Order Sim',
  acquisition_summary: 'Summary',
  acquisition_resources_error: 'Could not find available numbers. Please search again!',
  acquisition_monthly: ' /Month',
  acquisition_total_cost: 'Total Cost',
  acquisition_total_cost_subtitle: 'This is the price you will be paying',
  acquisition_start_date: 'Start date',
  acquisition_contract_duration: 'Duration',
  acquisition_contract_duration_value: '%1$s Months',
  acquisition_contract_duration_value_one: '%1$s Month',
  acquisition_plan_monthly_cost: 'New plan monthly cost',
  acquisition_plan_breakdown: 'Breakdown',
  acquisition_breakdown_title: 'Your new Mobile plan',
  acquisition_plan_bonus: 'Bonus',
  acquisition_terms: "By tapping 'Confirm', you accept our",
  acquisition_terms_link: "terms and conditions",
  acquisition_policy: 'See return ',
  acquisition_policy_link: 'policy and terms and conditions',
  acquisition_terms_url: 'https://api-web-ci-vfal.vodafone.com/file/DigiAcq/TermsAndCond/EN.html',
  acquisition_policy: 'See return ',
  acquisition_policy_link: 'policy and terms and conditions',
  acquisition_policy_url: 'https://api-web-ci-vfal.vodafone.com/file/DigiAcq/MoreInfo/EN.html',

  lastNameNull: "LastName must not be null",
  minorAge: "Contact cannot be created for a Minor. Birthdate should be greater than 18 years.",
  invalidPlaceOfBirth: "Place of birth must be valid.",
  invalidPersonalNumber: "Personal Number present in invalid format",
  personalNumberExists: "Customer Personal Number already exists",
  invalidDate: "ID expirey date should be less than today's date",
  invalidID: "Please use a vailid ID",
  invalidAddressName: "Validation Error: Invalid value occurred in address name",
  simMismatch: "Scanned sim is not the same as the one ordered",
  acquisition_terms_modal_title: 'Terms and conditions',
  acquisition_policy_modal_title: 'Return policy',

  acquisition_close_modal: 'Close',
  acquisition_camera_unavailable: 'Camera unavailable',
  acquisition_camera_unavailable_subtitle: 'You cannot use this feature because camera is unavailable in your device',
  acquisition_camera_go_to_settings: 'Go to settingt',
  acquisition_camera_permission_denied_ios_subtitle: 'You need to give access to camera and microphone to take photos. Go to settings to give camera permissions',
  acquisition_camera_permission_denied: 'Permission denied',
  acquisition_camera_permission_denied_subtitle: 'You need to give access to camera to take photos. Go to settings to give camera permissions',

  acquisition_orders_cancel_button: 'Cancel',
  acquisition_orders_add_manually_id: 'Add manually',
  acquisition_orders_error_modal_header: 'SIM Activation',
  acquisition_orders_error_modal_title: 'Something went wrong!',
  acquisition_orders_error_modal_desc_contract: 'Unfortunately we were unable to read your photo. Add your contract number manually to proceed with the journey.',

  acquisition_order_add_manually_id_title: 'Add details',
  acquisition_order_add_manually_id_question: 'Having trouble?',
  acquisition_order_add_manually_id__contract_label: 'Contract Number',
  acquisition_order_add_manually_id_validation: 'Add a correct serial number.',
  acquisition_orders_add_manually_id_confirm_button: 'Confirm',
  acquisition_add_manually_id_contract_label: "Contract number",
  acquisition_scan_error_modal_header: "Sim Activation",
  acquisition_add_manually_id_sim_label: "Sim Serial",

  acquisition_camera_continue: 'Continue',
  acquisition_camera_retake_photo: 'Retake photo',
  acquisition_camera_front_id: 'Take a picture of the front part of your ID',
  acquisition_camera_back_id: 'Take a picture of the back part of your ID',
  acquisition_camera_selfie: 'Take a photo of your face',


  acquisition_scanning: 'Scaning...',
}

export default en
